"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const editCategory = (0, graphql_tag_1.default)`
  mutation docs_page_edit_category($categoryId: Int!, $name: String255!) {
    documents {
      editCategory(categoryId: $categoryId, name: $name) {
        name
        isProtected
        canEdit
        canDelete
        id
      }
    }
  }
`;
exports.default = editCategory;